module.exports = __webpack_public_path__ + "static/amazonKindle-dd1c5cea197eef5f8485924fce71c43d.png";